var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"dark":"","small":"","color":"indigo"},on:{"click":function($event){_vm.$emit('click', $event)}}},[_c('v-icon',[_vm._v("mdi-dice-multiple")]),_c('span',[_vm._v(_vm._s(_vm.gameName || _vm.dice))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }